// loader.js (source that ends up in main.min.js)
const loaderEl = document.querySelector(".c-loader");
const barEl = document.getElementById("js-loader-progress");
const html = document.documentElement;
const body = document.body;

function setLock(on) {
  [html, body].forEach((el) => el.classList.toggle("u-lock-scroll", on));
}

const Preloader = (() => {
  let progress = 0;
  const set = (n) => {
    progress = Math.min(100, n);
    if (barEl) barEl.style.width = progress + "%";
  };
  const bump = (n) => set(progress + n);
  const done = () => {
    set(100);
    loaderEl?.classList.add("c-loader--done");
    setLock(false);
  };
  return { set, bump, done };
})();

// Section pipeline (example)
async function hydrateInOrder(names) {
  for (const name of names) {
    const el = document.querySelector(`[data-section="${name}"]`);
    if (!el) continue;
    // call your section init here if needed...
    el.classList.add("is-ready", "u-reveal-in"); // reveal with utility
    Preloader.bump(8); // weight per section
    await new Promise((r) => setTimeout(r, 40)); // breathing room
  }
}

// Boot
document.addEventListener("DOMContentLoaded", async () => {
  setLock(true);
  Preloader.set(8); // DOM ready tick
  await hydrateInOrder([
    "header",
    "hero",
    "stats",
    "products",
    "gallery",
    "presence",
    "contact",
    "footer",
  ]);
  Preloader.done();
});
